import { Link } from "react-router-dom";
import { siteConfig } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-night-700/50 bg-[#1a1510]">
      <div className="mx-auto grid w-full max-w-7xl gap-8 px-4 py-12 md:px-6 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-cinnabar-600 text-parchment-100">
              <i className="ri-ghost-2-fill text-lg"></i>
            </span>
            <span className="hand-script text-2xl text-parchment-100">校园爆料</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-parchment-300/70">
            {siteConfig.slogan}。我们求证校园怪谈是真的吗，梳理学校未解传闻的线索，把校园旧事档案从传说还原回真实的人与事。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold tracking-wider text-parchment-100">快速导航</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-parchment-300/75">
            <li><Link to="/" className="transition hover:text-parchment-100">回到首页</Link></li>
            <li><Link to="/archive" className="transition hover:text-parchment-100">怪谈档案库</Link></li>
            <li><Link to="/about" className="transition hover:text-parchment-100">求证方式</Link></li>
            <li><Link to="/about#faq" className="transition hover:text-parchment-100">常见疑问</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold tracking-wider text-parchment-100">联系我们</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-parchment-300/75">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-amberlight-400"></i>
              <span>{siteConfig.contactEmail}</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-quill-pen-line text-amberlight-400"></i>
              <span>欢迎投稿校园传说</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-shield-check-line text-amberlight-400"></i>
              <span>匿名化 · 保护隐私</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-night-700/40">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-parchment-300/60 sm:flex-row md:px-6">
          <span>© {year} {siteConfig.name} · 求证校园怪谈，还原校园旧事档案的真相</span>
          <span className="flex items-center gap-4">
            <span>求真 · 存疑 · 尊重集体记忆</span>
          </span>
        </div>
      </div>
    </footer>
  );
}